module.exports = __webpack_public_path__ + "static/img/heat-treatmentA.4cb3314.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heat-treatmentA.png
// module id = HC0w
// module chunks = 1